module.exports = __webpack_public_path__ + "img/story-04.0f69ae29.png";